
<template>
  <el-select :disabled="disabled" :multiple="multiple" :collapse-tags="collapse" :value="value.id" filterable remote
    :placeholder="queryplace" clearable @input="change" @click.native="handleSelected()" :remote-method="remoteMethod">
    <el-option v-for="item in dataList" :key="item.id" :label="`${item.name}(${item.address})`"
      :value="item.id"></el-option>
  </el-select>
</template>

<script>
import { queryAllVenueList } from "../api/api";
export default {
  name: "VenueSelect",
  props: {
    value: {
      type: Object,
      default() {
        return {
          id: "",
          address: ""
        };
      },
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    multiple: {
      type: Boolean,
      default() {
        return false;
      },
    },
    collapse: {
      type: Boolean,
      default() {
        return false;
      },
    },
    queryplace: {
      type: String,
      default: function () {
        return "请选择场馆";
      }
    },
  },
  data() {
    return {
      allList: [],
      dataList: [],
      venueId: "",
      keySearch: ""
    };
  },
  methods: {
    remoteMethod(value) {
      this.keySearch = value;
      if(this.allList==null || this.allList.length==0){
        queryAllVenueList().then((res) => {
          this.allList = res.data.response;
          this.dataList = this.allList.filter(x=>x.name.indexOf(value)>=0 || (x.address!=null && x.address.indexOf(value)>=0));
        });
      }else{
        this.dataList = this.allList.filter(x=>x.name.indexOf(value)>=0 || (x.address!=null && x.address.indexOf(value)>=0));
      }
    },
    queryAllVenueList() {
      queryAllVenueList().then((res) => {
        this.allList = res.data.response;
        this.dataList = this.allList;
      });
    },
    change(val) {
      let selectedData = this.allList.find(x=>x.id==val);
      if(selectedData){
        this.$emit("input", selectedData);
      }
    },
    handleSelected() {
      // 主动触发点击事件
      this.keySearch = "";
      this.queryAllVenueList();
    },
    check(val) {
      if (this.value != null) {
        var index = this.allList.findIndex(s => s.id == this.value);
        if (index < 0) {
          this.keySearch = val;
          this.remoteMethod(val);
        }
      }
    }
  },
  watch: {
    "value": function (val) {
      this.check(val);
    }
  },
  mounted() {
    if (this.value) {
      this.venueId = this.value.id;
    }
    if (this.disabled) {
      this.disabled = this.disabled;
    }
    if (this.multiple) {
      this.multiple = this.multiple;
    }
    if (this.collapse) {
      this.collapse = this.collapse;
    }
    this.queryAllVenueList();
  },
};
</script>